<img class="header-content"
    [src]="!isProdEnv ? 'assets/img/planet/planet_logo_test.svg' : 'assets/img/planet/planet_logo.svg'" height="54" />
<h2>
    Something went wrong during the login!
</h2>
<p>
    If the problem persists, please open a ticket.
</p>
<app-planet-button text="Retry" (click)="onRetry()"></app-planet-button>